import { motion } from "framer-motion";
import aboutLogo from "../assets/Best_IT_Tranning_In_Noida.png";
import heroBg from "../assets/About_For_IT_Service.jpg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function AboutPage() {
  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>About Us | Nadezhda Venture - Best IT Training in Noida</title>
        <meta
          name="description"
          content="Learn about Nadezhda Venture — a B Corp-certified IT services company in Noida providing expert solutions in web, app development, digital marketing, and virtual staffing."
        />
        <meta
          name="keywords"
          content="About Nadezhda Venture, IT Company Noida, Best IT Company For Noida, Web Development Noida, App Development, Digital Marketing, Virtual Assistant Services"
        />
        <meta property="og:title" content="About Nadezhda Venture | Best IT Services Company in Noida" />
        <meta
          property="og:description"
          content="Nadezhda Venture empowers businesses with IT training, app and web development, digital marketing, and virtual staffing services."
        />
        <meta property="og:url" content="https://www.yourdomain.com/about" />
        <link rel="canonical" href="https://www.yourdomain.com/about" />
      </Helmet>

      {/* Hero Section */}
      <div
        className="relative h-[60vh] w-full flex items-center justify-center text-white bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <motion.div
          className="relative z-10 text-center max-w-3xl px-4"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
            About <span className="text-orange-500">Nadezhda Venture</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-6">
            Empowering businesses with technology, collaboration, and purpose.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-orange-500 hover:bg-orange-600 transition text-white font-semibold px-6 py-3 rounded-full shadow-lg"
          >
            Get in Touch
          </Link>
        </motion.div>
      </div>

      {/* About Content Section */}
      <section className="bg-white py-20 px-6 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold text-blue-900 mb-4">
              About <span className="text-orange-500"> Nadezhda Ventures</span>
            </h2>
            <div className="w-12 h-2 bg-blue-900 rounded-full mb-6" />
            <p className="text-gray-700 text-lg mb-6 leading-relaxed">
              Nadezhda Ventures is a global provider of IT services, virtual assistant staffing, and professional training solutions, 
              committed to empowering businesses with innovative, scalable, and cost-effective digital strategies. 
              Established with the vision to revolutionize business growth through digital transformation,
               Nadezhda Ventures has grown into a trusted name across diverse sectors including Travel, Education, Technology,
                Government, Retail, Branding, and Public Relations.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              We specialize in delivering custom software development, website and app design, digital marketing, 
              remote staffing, and industry-relevant certification courses — all tailored to help startups, SMEs, 
              and enterprises accelerate their growth.
            </p>
             <p className="text-gray-700 text-lg leading-relaxed">
             Our team of experts combines the latest technologies, agile development methodologies, 
             and modern design frameworks to build high-performance solutions that drive real results. 
             Whether you're looking for end-to-end IT services, skilled virtual assistants, or professional upskilling programs,
              Nadezhda Ventures is your strategic partner for business success.
            </p>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="flex justify-center"
          >
            <img
              src={aboutLogo}
              alt="Certified B Corporation"
              className="w-72 sm:w-80 lg:w-96 object-contain"
            />
          </motion.div>
        </div>
      </section>

      {/* Extended About Us Section */}
      <section className="bg-gray-50 py-20 px-6 md:px-16 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Why Choose <span className="text-orange-500">Nadezhda Venture?</span>
          </h2>
          <div className="w-16 h-1 bg-orange-500 rounded-full mx-auto mb-6" />
          <p className="text-gray-700 text-lg leading-relaxed">
           Driven by a commitment to excellence and customer satisfaction, we provide 24/7 client support,
            transparent communication, and tailor-made services designed to meet unique business requirements. 
            Our approach is rooted in research, allowing us to deliver error-free, 
            high-quality results while staying ahead of industry trends.
          </p>
           <p className="text-gray-700 text-lg leading-relaxed">
           As a forward-thinking, client-focused organization, Nadezhda Ventures helps businesses around the 
           world enhance digital presence, streamline operations, and build sustainable growth through smart,
            integrated solutions.
          </p>
        </motion.div>
      </section>

      {/* Our Values Section */}
      <section className="bg-white py-20 px-6 md:px-16 lg:px-24">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              Our Core <span className="text-orange-500">Values</span>
            </h2>
            <div className="w-16 h-1 bg-orange-500 rounded-full mx-auto" />
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Integrity & Trust</h3>
              <p className="text-gray-600">
                We believe in honest and transparent communication. Trust is the
                foundation of our relationships with clients and partners.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Innovation & Excellence</h3>
              <p className="text-gray-600">
                We are committed to staying at the forefront of technology and
                delivering solutions that exceed expectations.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Collaboration & Partnership</h3>
              <p className="text-gray-600">
                We foster a collaborative environment, working closely with our
                clients to achieve their strategic objectives.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.6 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Client Focus</h3>
              <p className="text-gray-600">
                Our clients' success is our priority. We tailor our services to
                meet their unique needs, ensuring satisfaction and measurable results.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.8 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Social Responsibility</h3>
              <p className="text-gray-600">
                As a B Corp, we are committed to making a positive impact on
                our community and the environment through sustainable practices.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 1.0 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-800 mb-2">Continuous Learning</h3>
              <p className="text-gray-600">
                The IT landscape evolves rapidly, and so do we. We are dedicated
                to continuous learning and development for our team.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Our Mission & Vision Section */}
      <section className="bg-gray-50 py-20 px-6 md:px-16 lg:px-24">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              Our <span className="text-orange-500">Mission</span>
            </h2>
            <div className="w-16 h-1 bg-orange-500 rounded-full mb-6" />
            <p className="text-gray-700 text-lg leading-relaxed">
              At Nadezhda Ventures, our mission is to go beyond individual deliverables 
              and create lasting value that resonates across clients, teams, and the organization as a whole. 
              We are driven by a shared vision that prioritizes the evolving needs of our customers,
             empowers our workforce, and strengthens our foundation.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              Our <span className="text-orange-500">Vision</span>
            </h2>
            <div className="w-16 h-1 bg-orange-500 rounded-full mb-6" />
            <p className="text-gray-700 text-lg leading-relaxed">
              At Nadezhda Ventures, we believe that continuous learning is the cornerstone of growth — it expands horizons and fuels innovation.
              Our vision is to build a more agile, competitive, and future-ready organization by leveraging a
               distributed global workforce and harnessing the power of transformative technologies. 
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              Our <span className="text-orange-500">Commitments</span>
            </h2>
            <div className="w-16 h-1 bg-orange-500 rounded-full mb-6" />
            <p className="text-gray-700 text-lg leading-relaxed">
              At Nadezhda Ventures, customer satisfaction is at the core of everything we do. 
              Through our tailored IT solutions, virtual staffing services, and professional training programs,
               we ensure that every client receives results aligned with their goals. We believe in 
               building long-term partnerships based on trust, transparency, and a relentless drive for excellence.
            </p>
          </motion.div>
        </div>
      </section>
</div>
  );
}